import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { PASSWORD_REGEX } from 'helpers/passwordHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { authService } from '../../services/authService';
import { LoaderContext } from '../../components/common/Loader/Loader';
import './Account.scss';

export class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.initializeValidator();
    this.state = {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      passwordVisiblity: {
        passwordVisible1: false,
        passwordVisible2: false,
        passwordVisible3: false,
      },
      errorMessage: null,
    };
  }

  handleUnauthorizedResponse(error, email) {
    if (error?.response?.data?.error.code === 'TOO_MANY_FAILED_LOGIN_ATTEMPTS') {
      this.showError(error.response.data.error.message);
    } else if (error?.response?.status === 401) {
      this.tryNewPassword(email);
    } else {
      this.showError(error);
    }
    this.context.setLoaderVisibility(false);
  }

  togglePasswordVisibility = (index) => {
    this.setState((prevState) => ({
      passwordVisiblity: {
        ...prevState.passwordVisiblity,
        [`passwordVisible${index}`]: !prevState.passwordVisiblity[`passwordVisible${index}`],
      },
    }));
  };

  onChangeHandler = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  changePasswordClick = (event) => {
    event.preventDefault();
    this.setState({ errorMessage: null }, () => {
      this.validator.hideMessages();
      this.forceUpdate();

      if (this.validator.allValid()) {
        const user = authService.currentUser;
        this.context.setLoaderVisibility(true);
        this.changePordalPassword(user)
          ?.then(() => this.tryNewPassword(user.name))
          ?.catch((error) => this.handleUnauthorizedResponse(error, user.name));
      } else {
        this.showMessagesAndUpdate();
      }
    });
  };

  changePordalPassword(user) {
    return authService.changePordalPassword(
      user.name,
      this.state.oldPassword,
      this.state.newPassword,
      user?.userId
    );
  }

  tryNewPassword(email) {
    authService
      .login(email, this.state.newPassword)
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        this.showError(this.props.t('wrongPassword'));
      })
      .finally(() => {
        this.context.setLoaderVisibility(false);
      });
  }

  showError(error) {
    this.setState({ errorMessage: error }, () => {
      this.showMessagesAndUpdate();
    });
  }

  showMessagesAndUpdate() {
    this.validator.showMessages();
    this.forceUpdate();
  }

  initializeValidator() {
    this.validator = new SimpleReactValidator({
      className: 'invalid-field',
      validators: {
        samePasswords: {
          rule: () => this.state.newPassword === this.state.confirmNewPassword,
        },
        errorMessage: {
          rule: () => this.state.errorMessage === null,
        },
        password: {
          message: this.props.t('common:passwordRegex'),
          rule: (val, params, validator) =>
            validator.helpers.testRegex(val, PASSWORD_REGEX) && params.indexOf(val) === -1,
        },
      },
    });
  }

  render() {
    const { t } = this.props;
    const { passwordVisiblity } = this.state;

    return (
      <div className="change-password account-overflow property-overflow">
        <form className="" noValidate>
          <div className="form-group">
            <div className="input-icon-container">
              <input
                type={passwordVisiblity.passwordVisible1 ? 'text' : 'password'}
                className="form-control input-password"
                name="oldPassword"
                onChange={this.onChangeHandler}
                value={this.state.oldPassword}
                placeholder={t('oldPassword')}
              />
              <div className="eye-icon-container" onClick={() => this.togglePasswordVisibility(1)}>
                <FontAwesomeIcon
                  className="password-eye-icon"
                  icon={passwordVisiblity.passwordVisible1 ? faEye : faEyeSlash}
                />
              </div>
            </div>
            {this.validator.message(
              'oldPassword',
              this.state.oldPassword,
              'required|errorMessage',
              {
                messages: {
                  required: t('common:validationRequired', {
                    field: t('oldPassword'),
                  }),
                  errorMessage: this.state.errorMessage,
                },
              }
            )}
          </div>
          <div className="form-group">
            <div className="input-icon-container">
              <input
                type={passwordVisiblity.passwordVisible2 ? 'text' : 'password'}
                name="newPassword"
                className="form-control input-password"
                onChange={this.onChangeHandler}
                value={this.state.newPassword}
                id="inputNewPassword"
                placeholder={t('newPassword')}
              />
              <div className="eye-icon-container" onClick={() => this.togglePasswordVisibility(2)}>
                <FontAwesomeIcon
                  className="password-eye-icon"
                  icon={passwordVisiblity.passwordVisible2 ? faEye : faEyeSlash}
                />
              </div>
            </div>
            {this.validator.message('newPassword', this.state.newPassword, `required|password`, {
              messages: {
                required: t('common:validationRequired', {
                  field: t('newPassword'),
                }),
              },
            })}
          </div>
          <div className="form-group">
            <div className="input-icon-container">
              <input
                type={passwordVisiblity.passwordVisible3 ? 'text' : 'password'}
                name="confirmNewPassword"
                className="form-control input-password"
                onChange={this.onChangeHandler}
                value={this.state.confirmNewPassword}
                id="inputConfirmNewPassword"
                placeholder={t('confirmNewPassword')}
              />
              <div className="eye-icon-container" onClick={() => this.togglePasswordVisibility(3)}>
                <FontAwesomeIcon
                  className="password-eye-icon"
                  icon={passwordVisiblity.passwordVisible3 ? faEye : faEyeSlash}
                />
              </div>
            </div>
            {this.validator.message(
              'confirmNewPassword',
              this.state.confirmNewPassword,
              'required|samePasswords',
              {
                messages: {
                  required: t('common:validationRequired', {
                    field: t('confirmNewPassword'),
                  }),
                  samePasswords: t('common:passwordAndConfirmPasswordDifferent'),
                },
              }
            )}
          </div>
          <button type="submit" onClick={this.changePasswordClick.bind(this)} className="btn">
            {t('changePassword')}
          </button>
        </form>
      </div>
    );
  }
}
export default ChangePassword;

ChangePassword.contextType = LoaderContext;
